import React, { useEffect, useState } from 'react'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import CancelIcon from '@mui/icons-material/Cancel'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import WarningAmberIcon from '@mui/icons-material/WarningAmber'
import EditNoteSharpIcon from '@mui/icons-material/EditNoteSharp'
import DpsButton from '../../base/button/DpsButton'
import './CaseValidation.css'
import DpsSelectField from '../../base/select/DpsSelect'
import DpsImagePopup from '../../base/ImagePopup/DpsImagePopup'
import { Divider, Tooltip, Typography } from '@mui/material'
import DpsToggleSwitch from '../../base/toggleSwitch/DpsToggleSwitch'
import useAPIEndpoints from '../../../../models/api/apiEndpoints'
import CloseIcon from '@mui/icons-material/Close'
import DoneIcon from '@mui/icons-material/Done'
import { useFetch } from '../../../../models/api/api'
import InfoOutlineIcon from '../../../../assets/info.svg'
import summaryicon from '../../../../assets/summaryicon.svg'
import 'react-web-white-label/dist/app/global.css'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import DownloadDoneIcon from '@mui/icons-material/DownloadDone'
import FileCard from '../../base/fileCard/FileCard'
import LinearProgressBar from '../../base/linearProgressBar/LinearProgressBar'
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye'
import { format } from 'date-fns'

export default function CaseValidation({
  token,
  pcnNumber,
  summaryDetails,
  ceoFilesToShow,
  citizenFilesCombined,
  backOfficeData,
  viewDetails,
  setViewDetails,
  isViewChallengeEditable,
}) {
  const [vrmExpanded, setVrmExpanded] = useState(false)
  const [makeColorExpanded, setMakeColorExpanded] = useState(false)
  const [makeExpanded, setMakeExpanded] = useState(false)
  const { fetchData } = useFetch()
  const [toggleEnabled, setToggleEnabled] = useState({
    vrm: false,
    makeColor: false,
  })
  const APIEndPoints = useAPIEndpoints()
  const latestCorrespondence =
    backOfficeData.length > 0
      ? [...backOfficeData]
          .sort((a, b) => new Date(b.createdOn) - new Date(a.createdOn))
          .slice(0, 2)
      : []
  const selectedCeoAttachment = ceoFilesToShow?.[0] || null

  const openEvidenceView = (mode, selectedAttachment) => {
    const isVrmMode = mode === 'vrm'
    const isMakeMode = mode === 'make'
    const isCorrespondenceMode = mode === 'corres'

    setViewDetails((prev) => ({
      ...prev,
      vrm: isVrmMode,
      make: isMakeMode,
      ceo: mode === 'ceo',
      corres: isCorrespondenceMode,
      selectedAttachmentId: selectedAttachment?.id ?? null,
      selectedAttachmentSignature: null,
      selectedRow: selectedAttachment || null,
    }))
  }
  const [viewPermit, setViewPermit] = useState(false)
  const [viewPermitWarning, setViewPermitWarning] = useState(false)
  const [isCopied, setIsCopied] = useState(false)
  const handleCopySummary = () => {
    const summaryElement = document.querySelector('.summary-list')
    const textToCopy = summaryElement?.innerText
    navigator.clipboard.writeText(textToCopy ?? '')
    setIsCopied(true)
  }
  const [openIndex, setOpenIndex] = useState(null)

  const downloadImage = async (imageUrl, fileName = 'image.jpg') => {
    try {
      const response = await fetch(imageUrl, { mode: 'cors' })
      const blob = await response.blob()

      const blobUrl = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = blobUrl
      link.download = fileName

      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(blobUrl)
    } catch (error) {
      console.error('Download failed:', error)
    }
  }
  useEffect(() => {
    if (summaryDetails?.vrmOverrideReason) {
      setToggleEnabled((prevState) => ({
        ...prevState,
        vrm: true,
      }))
    }
    if (summaryDetails?.makeAndColorOverrideReason) {
      setToggleEnabled((prevState) => ({
        ...prevState,
        makeColor: true,
      }))
    }
  }, [
    summaryDetails?.vrmOverrideReason,
    summaryDetails?.makeAndColorOverrideReason,
  ])
  const overrideSelectOptions = [
    {
      id: '1',
      title: 'CEO inputted incorrectly ',
    },
    {
      id: '2',
      title: 'AI/Bot Misread',
    },
    {
      id: '3',
      title: 'VRM has been tampered with',
    },
    {
      id: '4',
      title: 'ANPR Misread',
    },
  ]
  const makeColorSelectOptions = [
    {
      id: '1',
      title: 'CEO inputted incorrect Make ',
    },
    {
      id: '2',
      title: 'AI/Bot Misread Make',
    },
    {
      id: '3',
      title: 'ANPR Misread Make',
    },
    {
      id: '4',
      title: 'CEO inputted incorrect Colour',
    },
    {
      id: '5',
      title: 'AI/Bot Misread Colour',
    },
    {
      id: '6',
      title: 'ANPR Misread Colour',
    },
    {
      id: '7',
      title: 'CEO inputted incorrect Make & Colour',
    },
    {
      id: '8',
      title: 'AI/Bot Misread Make & Colour',
    },
    {
      id: '9',
      title: 'ANPR Misread Make & Colour',
    },
  ]
  const [selectedOverrideData, setSelectedOverrideData] = useState({
    vrmId: summaryDetails?.vrmOverrideReasonId || 0,
    vrmReason: summaryDetails?.vrmOverrideReason || '',
    vrmValidity: summaryDetails?.isVrmOverrideValid || false,
    makeColorId: summaryDetails?.makeAndColorOverrideReasonId || 0,
    makeColorReason: summaryDetails?.makeAndColorOverrideReason || '',
    makeColorValidity: summaryDetails?.isMakeAndColorOverrideValid || false,
  })
  useEffect(() => {
    setSelectedOverrideData({
      vrmId: summaryDetails?.vrmOverrideReasonId || 0,
      vrmReason: summaryDetails?.vrmOverrideReason || '',
      vrmValidity: summaryDetails?.isVrmOverrideValid || false,
      makeColorId: summaryDetails?.makeAndColorOverrideReasonId || 0,
      makeColorReason: summaryDetails?.makeAndColorOverrideReason || '',
      makeColorValidity: summaryDetails?.isMakeAndColorOverrideValid || false,
    })
  }, [summaryDetails])
  // Base function for override/validity API calls
  const sendOverrideOrValidity = (payload) => {
    fetchData(
      APIEndPoints.PostOverRide.method, // 'POST'
      `${APIEndPoints.PostOverRide.url}?pcnNumber=${pcnNumber}`, // full URL
      {
        postData: {
          ...payload,
          AgentName: 'user1',
        },
      }
    ).catch((err) => console.log(err))
  }

  // Custom wrappers for each use case
  const sendVrmOverride = (selectedOption) => {
    sendOverrideOrValidity({
      vrmOverrideReasonId: Number(selectedOption?.id),
      vrmOverrideReason: selectedOption?.title,
    })
  }
  const sendContraventionAcceptance = (selectedOption) => {
    sendOverrideOrValidity({
      isConfirmedContravention: selectedOption,
    })
  }
  const sendMakeColorOverride = (selectedOption) => {
    sendOverrideOrValidity({
      makeAndColorOverrideReasonId: Number(selectedOption?.id),
      makeAndColorOverrideReason: selectedOption?.title,
    })
  }
  const sendVrmValidity = (checkstatus) => {
    sendOverrideOrValidity({
      isVrmOverrideValid: checkstatus,
    })
  }
  const sendMakeColorValidity = (checkstatus) => {
    sendOverrideOrValidity({
      isMakeAndColorOverrideValid: checkstatus,
    })
  }
  const permitDetails = [
    {
      label: 'From',
      value: summaryDetails?.permitStartDate?.split(' ')[0] || '-',
    },
    {
      label: 'To',
      value: summaryDetails?.permitEndDate?.split(' ')[0] || '-',
    },
    { label: 'Zone', value: summaryDetails?.permitLocation || '-' },
    {
      label: 'PCN Issued Date',
      value: summaryDetails?.pcnIssuedDate?.split(' ')[0] || '-',
    },
    {
      label: 'PCN Issued Zone',
      value: summaryDetails?.pcnIssuedLocation || '-',
    },
  ]
  useEffect(() => {
    setViewPermitWarning(permitDetails.some((permit) => permit.value === ''))
  }, [permitDetails])
  const [isContraventionAccepted, setIsContraventionAccepted] = useState(
    summaryDetails?.isConfirmedContravention ?? null
  )
  const handleacceptContravention = () => {
    setIsContraventionAccepted(true)
    sendContraventionAcceptance(true)
  }
  const handleRejectContravention = () => {
    setIsContraventionAccepted(false)
    sendContraventionAcceptance(false)
  }
  return (
    <div className="case-validation-container">
      <div className="case-validation-header">
        <div className="validation-header-left">
          <h6 className="title-header">Case Validation</h6>
        </div>
        {summaryDetails?.isFirstTimeOffender && (
          <button className="first-time-offender-button">
            First time offender
          </button>
        )}
      </div>
      {viewPermitWarning && (
        <section className="permit-details-box">
          <div className="warning-alert-box">
            <div className="warning-header">
              <WarningAmberIcon className="warning-icon" />
              <p className="warning-text">
                Permit was active when PCN was issued. Please review the
                details.
              </p>
            </div>

            <DpsButton
              onClick={() => setViewPermit(!viewPermit)}
              className={'override-button'}
              buttonVariant="text"
              buttonType="inherit"
              label={'VIEW DETAILS'}
              disabled={summaryDetails?.isVrmMatch}
              endAdronIcon={
                viewPermit ? <ExpandLessIcon /> : <ExpandMoreIcon />
              }
            ></DpsButton>
          </div>

          {viewPermit && (
            <div className="permit-details-grid">
              {permitDetails.map((item, index) => (
                <div key={index} className="permit-detail-item">
                  <p className="permit-detail-label">{item.label}</p>
                  <p className="permit-detail-value">{item.value}</p>
                </div>
              ))}
            </div>
          )}
        </section>
      )}
      <div className="match-container">
        {' '}
        <div className="validation-item">
          <div className="validation-item-left">
            {summaryDetails?.isVrmMatch ? (
              <CheckCircleIcon className="validation-icon-success" size={20} />
            ) : (
              <CancelIcon className="validation-icon-error" size={20} />
            )}
            <p className="validation-item-text">{`VRM ${
              summaryDetails?.isVrmMatch ? '' : 'Mis'
            }match`}</p>
          </div>

          <div
            className={
              summaryDetails?.isVrmMatch
                ? 'hide-override'
                : 'validation-item-view'
            }
          >
            {selectedOverrideData?.vrmValidity && (
              <button className="first-time-offender-button">
                Marked as valid{' '}
              </button>
            )}
            {selectedOverrideData?.vrmReason && (
              <span className="override-reason-text">Override:</span>
            )}
            {isViewChallengeEditable && (
              <DpsButton
                onClick={() => setVrmExpanded(!vrmExpanded)}
                className={'override-button'}
                buttonVariant="text"
                buttonType="primary"
                label={selectedOverrideData?.vrmReason || 'OVERRIDE'}
                disabled={summaryDetails?.isVrmMatch}
                endAdronIcon={
                  vrmExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />
                }
              ></DpsButton>
            )}
            {!isViewChallengeEditable && (
              <span className="override-reason-text">
                {selectedOverrideData?.vrmReason}
              </span>
            )}
          </div>
        </div>
        {vrmExpanded && (
          <div className="override-details-wrapper">
            <div className="vrm-container">
              <div className="vrm-title-box title-head">
                <div className="vrm-title">
                  <strong>VRM</strong>
                </div>
                <div className="vrm-content">
                  {summaryDetails?.vehicleVRM || '-'}
                </div>
              </div>
              <div className="vrm-title-box title-button">
                <div className="vrm-title">
                  <strong>Evidence</strong>
                </div>
                <div className="vrm-content">
                  <DpsButton
                    label="VIEW EVIDENCE"
                    onClick={() =>
                      openEvidenceView('vrm', selectedCeoAttachment)
                    }
                    buttonVariant="text"
                    buttonType="primary"
                  />
                </div>{' '}
              </div>
              <div className="vrm-title-box title-selector">
                <div className="vrm-title">
                  <strong>Override reason</strong>
                </div>
                <div className="vrm-content selector">
                  <DpsSelectField
                    options={overrideSelectOptions}
                    selectChangeHandler={(selectedTitle) => {
                      const selectedOption = overrideSelectOptions.find(
                        (opt) => opt.title === selectedTitle
                      )
                      setSelectedOverrideData((prevData) => ({
                        ...prevData,
                        vrmId: selectedOption?.id,
                        vrmReason: selectedOption?.title,
                      }))
                      sendVrmOverride(selectedOption)
                      setToggleEnabled((prevState) => ({
                        ...prevState,
                        vrm: true,
                      }))
                    }}
                    value={selectedOverrideData?.vrmId || ''}
                    size="small"
                    variant="outlined"
                    width="300px"
                    initialValue={{
                      title: selectedOverrideData?.vrmId || '',
                    }}
                    placeholder={selectedOverrideData?.vrmReason || ''}
                  />
                </div>
              </div>
              <div className="vrm-title-box title-switcher">
                <div className="vrm-title">
                  <strong>Mark as valid?</strong>
                </div>
                <div className="vrm-content switcher">
                  {' '}
                  <DpsToggleSwitch
                    color="primary"
                    label={selectedOverrideData?.vrmValidity ? 'Yes' : 'No'}
                    onChange={(e) => {
                      setSelectedOverrideData((prevData) => ({
                        ...prevData,
                        vrmValidity: e.target.checked,
                      }))
                      sendVrmValidity(e.target.checked)
                    }}
                    size="medium"
                    checked={selectedOverrideData?.vrmValidity}
                    disabled={!toggleEnabled.vrm}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
        <div
          className="validation-item"
          onClick={() => setMakeExpanded(!makeExpanded)}
        >
          <div className="validation-item-left">
            {summaryDetails?.isMakeAndColorMatch ? (
              <CheckCircleIcon className="validation-icon-success" size={20} />
            ) : (
              <CancelIcon className="validation-icon-error" size={20} />
            )}
            <p className="validation-item-text">{`Make & Colour  ${
              summaryDetails?.isMakeAndColorMatch ? '' : 'Mis'
            }match`}</p>{' '}
          </div>
          <div
            className={
              summaryDetails?.isMakeAndColorMatch
                ? 'hide-override'
                : 'validation-item-view'
            }
          >
            {selectedOverrideData?.makeColorValidity && (
              <button className="first-time-offender-button">
                Marked as valid{' '}
              </button>
            )}
            {selectedOverrideData?.makeColorReason && (
              <span className="override-reason-text">Override:</span>
            )}{' '}
            {isViewChallengeEditable && (
              <DpsButton
                onClick={() => setMakeColorExpanded(!makeColorExpanded)}
                className="override-button"
                buttonVariant="text"
                buttonType="primary"
                label={selectedOverrideData?.makeColorReason || 'OVERRIDE'}
                disabled={summaryDetails?.isMakeAndColorMatch}
                endAdronIcon={
                  makeColorExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />
                }
              />
            )}
            {!isViewChallengeEditable && (
              <span className="override-reason-text">
                {selectedOverrideData?.makeColorReason}
              </span>
            )}
          </div>
        </div>
        {makeColorExpanded && (
          <div className="override-details-wrapper">
            <div className="vrm-container">
              <div className="vrm-title-box title-head">
                <div className="vrm-title">
                  <strong>Make & Colour </strong>
                </div>
                <div className="vrm-content">
                  {summaryDetails?.vehicleMakeAndColor || '-'}
                </div>
              </div>
              <div className="vrm-title-box title-button">
                <div className="vrm-title">
                  <strong>Evidence</strong>
                </div>
                <div className="vrm-content">
                  <DpsButton
                    label="VIEW EVIDENCE"
                    onClick={() =>
                      openEvidenceView('make', selectedCeoAttachment)
                    }
                    buttonVariant="text"
                    buttonType="primary"
                  />
                </div>{' '}
              </div>
              <div className="vrm-title-box title-selector">
                <div className="vrm-title">
                  <strong>Override reason</strong>
                </div>
                <div className="vrm-content selector">
                  <DpsSelectField
                    options={makeColorSelectOptions}
                    selectChangeHandler={(selectedTitle) => {
                      const selectedOption = makeColorSelectOptions.find(
                        (opt) => opt.title === selectedTitle
                      )
                      setSelectedOverrideData((prevData) => ({
                        ...prevData,
                        makeColorId: selectedOption?.id,
                        makeColorReason: selectedOption?.title,
                      }))
                      sendMakeColorOverride(selectedOption)
                      setToggleEnabled((prevState) => ({
                        ...prevState,
                        makeColor: true,
                      }))
                    }}
                    value={selectedOverrideData?.makeColorReason || ''}
                    size="small"
                    variant="outlined"
                    width="300px"
                    initialValue={{
                      title: selectedOverrideData?.makeColorReason || '',
                    }}
                    placeholder={selectedOverrideData?.makeColorReason || ''}
                  />{' '}
                </div>
              </div>
              <div className="vrm-title-box title-switcher">
                <div className="vrm-title">
                  <strong>Mark as valid?</strong>
                </div>
                <div className="vrm-content switcher">
                  {' '}
                  <DpsToggleSwitch
                    color="primary"
                    label={
                      selectedOverrideData?.makeColorValidity ? 'Yes' : 'No'
                    }
                    onChange={(e) => {
                      setSelectedOverrideData((prevData) => ({
                        ...prevData,
                        makeColorValidity: e.target.checked,
                      }))
                      sendMakeColorValidity(e.target.checked)
                    }}
                    size="medium"
                    checked={selectedOverrideData?.makeColorValidity}
                    disabled={!toggleEnabled.makeColor}
                  />{' '}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <hr />
      <div className="question-box-container">
        <div className="question-box">
          <h6 className="title-sub-header">
            Does this evidence confirm the contravention?
          </h6>
          <div className="contravention-grp-btn">
            <div className="contravention-left">
              <DpsButton
                size="medium"
                label={'Yes'}
                startAdronIcon={<DoneIcon />}
                buttonVariant={
                  isContraventionAccepted === true ? 'contained' : 'outlined'
                }
                buttonType="primary"
                className={`contravention-left ${
                  !isViewChallengeEditable && 'disable-contravention-btn'
                }`}
                onClick={handleacceptContravention}
                // disabled={!isViewChallengeEditable}
              />
            </div>
            <div className="contravention-right">
              <DpsButton
                size="medium"
                label={'No'}
                startAdronIcon={<CloseIcon />}
                buttonVariant={
                  isContraventionAccepted === false ? 'contained' : 'outlined'
                }
                buttonType="primary"
                onClick={handleRejectContravention}
                className={`contravention-right ${
                  !isViewChallengeEditable && 'disable-contravention-btn'
                }`}
                // disabled={!isViewChallengeEditable}
              />
            </div>
          </div>
        </div>

        <div className="evidence-action-wrapper">
          <div className="contravention-box">
            <div className="contravention-header">
              <p className="contravention-label">Contravention Description</p>
            </div>

            <div className="contravention-details-ceo">
              <p>Contravention Code: </p>
              <p>{summaryDetails?.contraventionCode}</p>
              <p>-</p>
              <p>{summaryDetails?.contraventionDescription}</p>
            </div>
          </div>
          <div className="evidence-box">
            <div className="evidence-header">
              <p className="evidence-label">Evidence:</p>
            </div>

            <DpsButton
              label={'VIEW EVIDENCE'}
              buttonVariant="text"
              onClick={() => openEvidenceView('ceo', selectedCeoAttachment)}
              buttonType="primary"
            />
          </div>
        </div>
      </div>
      <hr />
      <div className="ceo-notes-section">
        <div className="ceo-notes-header">
          <EditNoteSharpIcon className="notes-icon" />
          <h6 className="title-sub-header">CEO Notes</h6>
        </div>
        <div
          className="case-list"
          dangerouslySetInnerHTML={{
            __html: summaryDetails?.ceoHtmlSummary
              ? summaryDetails?.ceoHtmlSummary
              : '<p>No CEO notes to display</p>',
          }}
        ></div>
      </div>
      <h6 className="title-header">Challenge</h6>

      <section className="challenge-detail-section">
        <div className="challenge-detail-container">
          {' '}
          <div className="challenge-left-sec">
            {' '}
            <strong>Challenge Details</strong>
            <Divider orientation="vertical" variant="fullWidth" flexItem />
            <p>{summaryDetails?.challengeSummaryCreatedDate || '-'}</p>
          </div>
          <div className="challenge-right-sec">
            <p>OCR Confidence Score </p>
            <LinearProgressBar value={summaryDetails?.ocrScore} />
            <Tooltip
              placement="bottom-start"
              title=<div>
                <ul className="tool-list-tip">
                  <li>
                    <strong>90–100%:</strong> High Accuracy – Clear, reliable
                    text. Minimal or no corrections needed.
                  </li>
                  <li>
                    <strong>70–89%:</strong> Moderate Accuracy – Mostly
                    accurate. Some minor errors may need correction.
                  </li>
                  <li>
                    <strong>40–69%:</strong> Low Accuracy – Several errors
                    expected. Careful review recommended.
                  </li>
                  <li>
                    <strong>0–39%:</strong> Very Low Accuracy – Poor
                    recognition. Text likely unusable without major corrections.
                  </li>
                </ul>
              </div>
            >
              <img src={InfoOutlineIcon} alt="info" />
            </Tooltip>
          </div>
        </div>
        <Divider orientation="horizontal" variant="fullWidth" flexItem />

        <div className="challenge-sub-section">
          {' '}
          <div className="challenge-summary-box">
            <div className="summary-head">
              <div className="summary-title">
                {' '}
                {<img src={summaryicon} alt="info" />}
                <strong>Challenge Summary</strong>
              </div>
              {summaryDetails?.citizenHtmlSummary && (
                <DpsButton
                  startAdronIcon={
                    isCopied ? <DownloadDoneIcon /> : <ContentCopyIcon />
                  }
                  label={isCopied ? 'COPIED' : 'COPY SUMMARY'}
                  onClick={handleCopySummary}
                  buttonVariant="text"
                  buttonType="primary"
                />
              )}
            </div>

            <div
              className="summary-list"
              dangerouslySetInnerHTML={{
                __html: summaryDetails?.citizenHtmlSummary
                  ? summaryDetails?.citizenHtmlSummary
                  : '<p>No summary available</p>',
              }}
            ></div>
            <div className="supported-documents">
              <div className="supported-doc-head">
                {' '}
                <strong>Supported Documents</strong>
              </div>
              {citizenFilesCombined.every((doc) => !doc?.fileName) ? (
                <div>No supported documents to view</div>
              ) : (
                citizenFilesCombined.map((doc, index) => (
                  <div key={index} className="supported-doc-list">
                    <div className="doc-item">
                      <p>Description: {doc.fileDescription}</p>
                      <FileCard
                        onClick={() =>
                          downloadImage(doc.attachmentURL, doc.fileName)
                        }
                        fileName={doc?.fileName}
                        fileSize={doc?.fileSize}
                        filePath={doc?.attachmentURL}
                      />
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      </section>
      <section className="corres-section">
        <h6 className="title-header">Correspondences</h6>
        <div className="corres-container">
          {' '}
          {latestCorrespondence.length > 0 ? (
            latestCorrespondence.map((corres, index) => (
              <div className="correspondences-item" key={index}>
                <div className="corres-detail-box">
                  <div className="corress-date">
                    {format(new Date(corres.createdOn), 'dd-MM-yyyy HH:mm')}
                  </div>
                </div>

                <DpsImagePopup
                  open={openIndex === index}
                  onClose={() => setOpenIndex(null)}
                  headerContent={
                    <Typography variant="h6">
                      {format(new Date(corres.createdOn), 'dd-MM-yyyy HH:mm')}
                    </Typography>
                  }
                  footerContent={<Typography variant="body2"></Typography>}
                  popupImage={corres}
                  handleDeleteItem={() => {}}
                  showThumbnails={true}
                  buttonConfig={['']}
                />

                {/* <DpsButton
                  label={'View Correspondence'}
                  buttonVariant="text"
                  onClick={() => setViewDetails((prev) => ({ ...prev, corres: true }))}
                  buttonType="primary"
                /> */}
                <RemoveRedEyeIcon
                  onClick={() => openEvidenceView('corres', corres)}
                />
              </div>
            ))
          ) : (
            <div>No Correspondence to view</div>
          )}
        </div>
      </section>
    </div>
  )
}
